// src/frontend/src/serviceWorkerRegistration.ts

export function register(): void {
    if (!('serviceWorker' in navigator)) return;

    window.addEventListener('load', () => {
        // BASE_URL already ends in a slash, so no separator is needed here.
        const swUrl = `${import.meta.env.BASE_URL}service-worker.js`;
        navigator.serviceWorker.register(swUrl).catch(error => {
            console.error('Service Worker registration failed:', error);
        });
    });
}

export function unregister(): void {
    if (!('serviceWorker' in navigator)) return;

    navigator.serviceWorker.ready
        .then(registration => registration.unregister())
        .catch(error => console.error(error.message));
}
